/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudWatchMetrics extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudWatchMetrics");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudWatchMetrics.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudWatchMetrics>): BackgroundJobPayloadForPeriodicCloudWatchMetrics {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudWatchMetrics(), model);
        BackgroundJobPayloadForPeriodicCloudWatchMetrics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudWatchMetrics>): BackgroundJobPayloadForPeriodicCloudWatchMetrics {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudWatchMetrics.newInstance(<BackgroundJobPayloadForPeriodicCloudWatchMetrics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudWatchMetrics) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudWatchMetrics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudWatchMetrics): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudWatchMetrics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
